<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { formatDate } from "@/js/utils/formatDate";
import { isSameDay, isSameYear } from "date-fns";

const countdownDate = ref(null)
const interval = ref(null)

const props = defineProps({
    maintenance:{
        type: Array,
        required: true,
    },
    now:{
        type: Date,
        required: true,
    }
})

const sortedMaintenance = computed(() => {
    return [...props.maintenance].sort((a, b) => {
        if (a.start_at !== b.start_at) {
            return new Date(a.start_at).getTime() - new Date(b.start_at).getTime();
        }
        if (a.end_at !== b.end_at) {
            return new Date(a.end_at).getTime() - new Date(b.end_at).getTime();
        }
        return 0;
    });
})

const dispMaintenance = computed(() => {
    if (!sortedMaintenance.value.length) {
       return null;
    }
    const currentMilliseconds  = props.now.getTime();
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    return sortedMaintenance.value.find((item, index) => {
        const isWithin24Hours = (new Date(item['start_at']).getTime() - currentMilliseconds) <= millisecondsInADay;
        const isMaintenanceDone = item['end_at'] && new Date(item['end_at']).getTime() < currentMilliseconds;
        return isWithin24Hours && (item['end_at']===null || !isMaintenanceDone);
    });
})


const isShowMaintenance = computed(() => {
        return dispMaintenance.value != null;
    })

const maStartDate = computed(() => {
        if (dispMaintenance.value) {
            return formatDate(dispMaintenance.value['start_at'], 'YYYY/MM/DD hh:mm');
        }
        return null;
    })

const maEndDate = computed(() => {
        if (!dispMaintenance.value) return null;
        if (!dispMaintenance.value['end_at']) return '未定';
        const startAtDay = new Date(dispMaintenance.value['start_at']);
        const endAtDay = new Date(dispMaintenance.value['end_at']);
        let format = 'YYYY/MM/DD hh:mm';
        if (isSameDay(startAtDay, endAtDay)) {
            format = 'hh:mm';
        } else if (isSameYear(startAtDay, endAtDay)) {
            format = 'MM/DD hh:mm';
        }
        return formatDate(dispMaintenance.value['end_at'], format);
    })

const maHref = computed(() => {
    return dispMaintenance.value?.url;
})

const isShowCountdown = computed(() => {
    if (dispMaintenance.value) {
        const now = props.now;
        const startDate = new Date(dispMaintenance.value['start_at']);
        const diff = startDate.getTime() - now.getTime();
        if (diff <= (1000 * 60 * 60)) {
            countdownDate.value = now;
            return true;
        }
    }
    return false;
})

const countdownMessage = computed(() => {
    if (!isShowCountdown.value) {
        return null
    }
    const startDate = new Date(dispMaintenance.value['start_at']);
    const limitMinutes = Math.ceil(Math.abs(startDate.getTime() - countdownDate.value.getTime()) / (60 * 1000));
    if (limitMinutes <= 5) {
        clearInterval(interval.value);
        return 'もうすぐメンテナンスを開始します'
    }
    return `開始まであと${limitMinutes}分`;
})

onMounted(()=> {
    if (isShowCountdown.value) {
        interval.value = setInterval(() => {
            countdownDate.value = new Date(countdownDate.value.setSeconds(countdownDate.value.getSeconds() + 10));
        }, 1000 * 10);
    }
})

// 念のため
onUnmounted(()=>{
    clearInterval(interval.value)
})

defineOptions({
    name: "HeaderMaintenanceInfo",
})
</script>

<template>
    <section
        v-if="isShowMaintenance"
        class="l-maintenance"
    >
        <a :href="maHref" class="maintenance">
            <h1>メンテナンス<br>のお知らせ</h1>
            <dl
                v-if="isShowCountdown"
                class="maintenance-countdown"
            >
                <dt>{{ countdownMessage }}</dt>
                <dd>{{ maStartDate }}～{{ maEndDate }}
                </dd>
            </dl>
            <dl
                v-else
                class="maintenance-schedule">
                <dt>期間</dt>
                <dd>{{ maStartDate }}～{{ maEndDate }}
                </dd>
            </dl>
        </a>
    </section>
</template>

<style scoped>

</style>
